<template>
<div class="chapter">
<div class="inner_page">
<p class="center"><a id="piv"></a> THE HARVARD COMMON PRESS<br/>
535 Albany Street<br/>
Boston, Massachusetts 02118<br/>
<a href="http://www.harvardcommonpress.com" target="_blank">www.harvardcommonpress.com</a></p>
<p class="center">© 2003 by Liz Scott<br/>
All rights reserved. No part of this publication may be reproduced or<br/>
transmitted in any form or by any means, electronic or mechanical, including<br/>
photocopying, recording, or any information storage or retrieval system, without<br/>
permission in writing from the publisher.</p>
<p class="center">Printed in the United States of America<br/>
Printed on acid-free paper</p>
<p class="center"><em>Library of Congress Cataloging-in-Publication Data</em><br/>
Scott, Liz.<br/>
The sober kitchen : recipes and advice for a lifetime of sobriety / Liz Scott.<br/>
p. cm.<br/>
Includes bibliographical references and index.<br/>
ISBN 1-55832-220-5 (hc : alk. paper)—ISBN 1-55832-221-3 (pbk : alk. paper)<br/>
1. Cookery. 2. Alcoholism—Diet therapy. I. Title.<br/>
TX714.S3925 2003<br/>
641.5'631—dc21</p>
<p class="center">2003007557</p>
<p class="center">Special bulk-order discounts are available on this and other Harvard Common Press books.<br/>
Companies and organizations may purchase books for premiums or resale, or may arrange a<br/>
custom edition, by contacting the Marketing Director at the address above.</p>
<p class="center">10 9 8 7 6 5 4 3 2 1</p>
<p class="center">Cover design by Night &amp; Day Design<br/>
Cover photograph by Amos Chan<br/>
Interior design by Ralph Fowler</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front01.vue?8c1bf480